import { Component, NgZone, OnInit, inject, signal, ViewEncapsulation } from "@angular/core";
import { LANG_IT, PAGES } from "../constants/constants";
import { NgxSpinnerService, NgxSpinnerComponent } from "ngx-spinner";
import { SupportsService } from "src/app/services/supports.service";
import { AuthService } from "src/app/auth/auth.service";
import { formatDate, NgClass } from "@angular/common";
import { Subject } from "rxjs";
import { MenuItem } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { Bind } from "primeng/bind";
import { Drawer } from "primeng/drawer";
import { PanelMenu } from "primeng/panelmenu";
import { RouterLinkActive, RouterLink, RouterOutlet } from "@angular/router";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";
import { LANGUAGES, tr } from "../i18n/i18n";

import { TPipe } from "../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-admin",
    templateUrl: "./admin.component.html",
    styleUrl: "./admin.component.less",
    encapsulation: ViewEncapsulation.None,
    imports: [TPipe, Bind, Drawer, PanelMenu, RouterLinkActive, NgClass, RouterLink, Select, FormsModule, RouterOutlet, NgxSpinnerComponent]
})
export class AdminComponent implements OnInit {
  private spinner = inject(NgxSpinnerService);
  private supportsService = inject(SupportsService);
  private authService = inject(AuthService);
  translate = inject(TranslateService);
  private zone = inject(NgZone);

  readonly currentUser = signal<any>(undefined);
  readonly currentLang = signal<string>(undefined);
  readonly langOptions = signal<any[]>([]);
  selectedLang: any;
  submitted = false;
  returnUrl: string;
  error: {};
  loginError: string;
  username: string;
  user_id: string;
  flag = true;
  readonly display = signal(false);
  light = true;
  readonly items = signal<MenuItem[]>(undefined);

  password: string;
  first_name: string;
  last_name: string;
  readonly pages = signal<any[]>(undefined);

  firstName = "John";
  lastName = "Doe";
  supportsCount: any;
  myDate = formatDate(new Date(), "dd/MM/yyyy", "en");
  notify$ = new Subject();

  constructor() {
    this.currentUser.set(JSON.parse(localStorage.getItem("currentUser") || "[]"));
    this.currentLang.set(this.translate.currentLang || localStorage.getItem("selectedLang") || "it");
    this.langOptions.set(LANGUAGES);

    this.pages.set(PAGES);

    localStorage.setItem(
      "expiredDate",
      this.addMinutes(new Date(), 60).getTime().toString(),
    );
  }

  ngOnInit() {
    this.buildMenu();
    this.translate.onLangChange.subscribe(() => this.buildMenu());
  }

  private buildMenu() {
    this.items.set([
      {
        label: tr("Dashboard"),
        icon: "pi pi-pw pi-inbox",
        routerLink: "/admin/dashboard",
      },

      {
        label: tr("Calendario"),
        icon: "pi pi-fw pi-calendar",
        routerLink: "/admin/calendar/",
      },

      {
        label: tr("Prenotazioni"),
        icon: "pi pi-fw pi-calendar-plus",
        routerLink: "/admin/bookings/",
      },

      {
        label: tr("Fatturazione"),
        icon: "pi pi-fw pi-credit-card",
        routerLink: "/admin/billings/",
      },

      {
        label: tr("Clienti"),
        icon: "pi pi-fw pi-user",
        routerLink: "/admin/clients/",
      },
      {
        label: tr("Camere"),
        icon: "pi pi-fw pi-home",
        routerLink: "/admin/rooms/",
      },

      {
        label: tr("Configurazioni"),
        icon: "pi pi-fw pi-cog",
        routerLink: "/admin/settings/",
      },
      {
        label: tr("Pagine"),
        icon: "pi pi-fw pi-comments",
        routerLink: "/admin/pages/",
      },

      {
        label: tr("Dipendenti"),
        icon: "pi pi-fw pi-user",
        routerLink: "/admin/employees/",
      },

      {
        label: tr("Logout"),
        icon: "pi pi-sign-in",
        command: (event) => {
          this.logout();
        },
      },
    ]);
  }

  addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
  }

  logout() {
    this.authService.logout();
  }

  onLanguageChange(): void {
    this.translate.use(this.currentLang());
    localStorage.setItem("selectedLang", this.currentLang());
  }
}
